<template>
  <div class="locker-return-fail">
    <div class="locker-return-fail-card" role="alert">
      <div class="locker-return-fail-icon" aria-hidden="true">!</div>
      <h2 class="locker-return-fail-title">
        {{ $t('lockerReturn.failure.title') }}
      </h2>
      <p class="locker-return-fail-message">
        {{ $t(`lockerReturn.failure.errors.${errorKey}`) }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LockerReturnFail',
  props: {
    errorKey: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.locker-return-fail {
  display: flex;
  justify-content: center;
  padding-top: 20px;
}

.locker-return-fail-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 680px;
  padding: 32px;
  border: 1px solid #e1e1e1;
  border-radius: 10px;
  background-color: #fff;
  color: #1a1a1a;
  text-align: center;
}

.locker-return-fail-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  margin-bottom: 20px;
  border-radius: 50%;
  background-color: #fbe9e7;
  color: #c62828;
  font-size: 30px;
  font-weight: 700;
}

.locker-return-fail-title {
  margin-bottom: 16px;
  font-family: 'Proxima Nova';
  font-size: 2rem;
  font-weight: 500;
  line-height: 1.2;
}

.locker-return-fail-message {
  max-width: 560px;
  margin-bottom: 24px;
  font-size: 20px;
  line-height: 1.4;
}

.locker-return-fail-support-link {
  display: inline-block;
  padding: 12px 24px;
  border-radius: 8px;
  background-color: #f68b24;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  text-decoration: none;
}

.locker-return-fail-support-link:hover {
  background-color: #f4a154;
}

@media (max-width: 768px) {
  .locker-return-fail-card {
    padding: 24px 16px;
  }

  .locker-return-fail-title {
    font-size: 1.6rem;
  }

  .locker-return-fail-message {
    font-size: 18px;
  }
}
</style>
